module.exports = __webpack_public_path__ + "img/emergency_assistance_icon.b9e6955f.png";